import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1310Component } from './kymw1310.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetPlanMultiPublishService } from './api-services/get-plan-multi-publish.service';
import { RegistPlanMultiPublishService } from './api-services/regist-plan-multi-publish.service';

/**
 * Ｗ掲載設定画面 モジュール設定クラス
 *
 * @export KYMW1310Module
 * @class KYMW1310Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
  ],
  declarations: [
    KYMW1310Component,
  ],
  providers: [
    GetPlanMultiPublishService,
    RegistPlanMultiPublishService,
  ],
})
export class KYMW1310Module {
}
